module.exports = {"attributes":{"width":"9","height":"21","viewBox":"0 0 9 21","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M34.9837064,44.3295406 L34.9837064,34.6530516 L37.6482855,34.6530516 L38.0039062,31.3175756 L34.9837064,31.3175756 L34.9888604,29.6472599 C34.9888604,28.7760151 35.0713232,28.3120385 36.3185729,28.3120385 L37.9832906,28.3120385 L37.9832906,24.9765625 L35.3187115,24.9765625 C32.1181244,24.9765625 30.9945688,26.5953252 30.9945688,29.3121658 L30.9945688,31.3124203 L29,31.3124203 L29,34.6478963 L30.9945688,34.6478963 L30.9945688,44.3243853 L34.9837064,44.3243853 L34.9837064,44.3295406 Z\" transform=\"translate(-29 -24)\" fill=\"currentColor\" fill-rule=\"evenodd\"/>"}
const React = require('react');

function svgLoader(svg) {
	const { viewBox, width, height } = svg.attributes;

	// eslint-disable-next-line react/display-name
	return function (props) {
		return React.createElement(
			'svg',
			Object.assign(
				{
					dangerouslySetInnerHTML: { __html: svg.content },
					fill: 'currentColor',
					height,
					viewBox,
					width,
				},
				props,
			),
		);
	};
}

module.exports = svgLoader(module.exports);
